import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import NotificationButton from '../notification-button';
import SearchButton from '../search-button';
import IconButton from '../icon-button';
import { MemberIcon } from '../../components/icons';
import ProtectedButton from '../../containers/protected-button';
import HeaderAvatarImage from '../../components/header-avatar-image';
import ProfileActionsButton from '../../components/profile-actions-button';
import PrivateProfileActions from '../../containers/private-profile-actions';
import withAuth from '../../hoc/with-auth';
import withEnvironment from '../../hoc/with-environment';
import withTranslate from '../../hoc/with-translate';
import styles from './header-buttons.scss';

export const HeaderButtons = ({ currentUser, isAuthenticated, navigation: { MembersLink, NotificationsLink }, t }) =>
  <div className={classNames(styles.container, 'header-buttons')}>
    <div className={styles.searchButtonSpacing}>
      <SearchButton/>
    </div>
    <div className={styles.membersButtonSpacing}>
      <IconButton component={MembersLink} icon={MemberIcon} iconClassName="button-primary-icon-fill"/>
    </div>
    {renderNotificationButton(isAuthenticated, NotificationsLink)}
    {renderAvatar(isAuthenticated, currentUser, t)}
  </div>;

function renderNotificationButton(isAuthenticated, NotificationsLink) {
  if (isAuthenticated) {
    return (
      <div className={styles.notificationButtonSpacing}>
        <NotificationButton
          component={NotificationsLink}
          iconClassName="button-primary-icon-fill"
          bubbleClassName="icon-secondary-background-color"
        />
      </div>
    );
  }
}

function renderAvatar(isAuthenticated, currentUser, t) {
  if (isAuthenticated) {
    return (
      <ProfileActionsButton
        actionsContainerClassName={styles.profileActions}
        position={ProfileActionsButton.POSITION_RIGHT}
        icon={<HeaderAvatarImage user={currentUser}/>}
      >
        <PrivateProfileActions user={currentUser}/>
      </ProfileActionsButton>
    );
  }

  return (
    <ProtectedButton
      tagName={'span'}
      className={classNames(styles.signUp, 'button-primary-text-color', 'header-buttons__sign-up')}
    >
      {t('header-buttons.sign-up')}
    </ProtectedButton>
  );
}

HeaderButtons.propTypes = {
  currentUser: PropTypes.object,
  isAuthenticated: PropTypes.bool,
  navigation: PropTypes.object,
  t: PropTypes.func,
};

export default flowRight(
  withAuth,
  withEnvironment({ navigation: 'navigation' }),
  withTranslate
)(HeaderButtons);



// WEBPACK FOOTER //
// ./app/components/header-buttons/header-buttons.js